import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { links } from '[theme-lib]/links';

import { priceFormat, priceFormatSeparate } from 'apps/products/utils/priceFormat';
import { reportCheckoutButtonClicked } from 'apps/header/actions/checkoutButton';
import basketModes from 'apps/basket/utils/basketModes';

export default function TrolleyMenuHeaderSummary({ basket, router }) {
  const value = priceFormatSeparate({ value: basket.value, inPound: true });

  const onCheckoutButtonClick = (event) => {
    const redirect = router.push({
      pathname: event.target.href,
    });

    reportCheckoutButtonClicked('MOBILE_SIDEBAR_TOP', redirect);
  };

  return (
    <div className="hd-trolleyMenuHeaderSummary">
      <div className="hd-trolleyMenuHeaderSummary__total">
        {value[0]}
        <span className="hd-trolleyMenuHeaderSummary__totalFraction">{value[1]}</span>
      </div>
      <div className="hd-trolleyMenuHeaderSummary__offer">
        Savings{' '}
        <span className="hd-trolleyMenuHeaderSummary__offerValue">
          {priceFormat({ value: basket.offerSavings, inPound: true })}
        </span>
      </div>

      {basket.checkoutAllowed ?
        (
          <Link
            className="btn-checkout btn-action hd-trolleyMenuHeaderSummary__btnCheckout"
            to={links.CHECKOUT}
            onClick={onCheckoutButtonClick}
          >
            Checkout
          </Link>
        ) : [
          <div key="min-order" className="hd-trolleyMenuHeaderSummary__minOrder">
            Minimum order {priceFormat({ value: basket.minimumOrderValue, inPound: true })}
          </div>,
          <span
            key="checkout-btn"
            // eslint-disable-next-line max-len
            className="btn-checkout btn-action hd-trolleyMenuHeaderSummary__btnCheckout hd-trolleyMenuHeaderSummary__btnCheckout--belowMinOrder"
          >
            Checkout
          </span>,
        ]
      }
    </div>
  );
}

TrolleyMenuHeaderSummary.propTypes = {
  basket: PropTypes.shape({
    mode: PropTypes.oneOf(Object.values(basketModes)).isRequired,
    value: PropTypes.number.isRequired,
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};
